import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';
import { DTypeFormRadioField } from '@grupo-constant/next-dtype/form';
import { DTypeViewableCol } from '@grupo-constant/next-dtype/types';
import { DTypeFormFieldComponent } from '../../dtype-field.model';

@Component({
    selector: 'radio-field-component',
    templateUrl: './radio-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatRadioModule]
})
export class DtypeRadioFieldComponent implements DTypeFormFieldComponent, OnInit {

    @Input() field: DTypeFormRadioField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    constructor() { }

    ngOnInit() {
        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }
    }

}
